import React from 'react';
import { Button } from 'react-bootstrap';
import { useToast } from '../context/ToastProvider';
import { useAuth } from '../context/AuthContext';

const LogoutButton = ({ onClose }) => {
  const { showToast } = useToast();
  const { token, logout } = useAuth();

  const handleLogout = async () => {
    onClose?.(); 

    try {
      await logout();
    } catch (err) {
      showToast(`Logout error: ${err.message}`, "danger");
    }
  };

  const handleLogin = () => {
    onClose?.(); 

    window.location.href = '/login';
  }

  return (
    <>
    {
      token ?
      (
        <Button className="bg-gr-h br-0" onClick={handleLogout} >
          Logout
        </Button>
      )
      :
      (
        <Button onClick={handleLogin} >
          Login
        </Button>
      )
    }
    </>
  );
};

export default LogoutButton;
